import { add } from "date-fns";
import { tryParseDate } from "../utils/timestamp.utils";

export function getMountainTimeOffset(date: string | Date): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const year = d.getFullYear();
  const marchSecondSunday = new Date(year, 2, 8 + ((7 - new Date(year, 2, 1).getDay()) % 7));
  const novFirstSunday = new Date(year, 10, 1 + ((7 - new Date(year, 10, 1).getDay()) % 7));
  const isDST = d >= marchSecondSunday && d < novFirstSunday;
  return isDST ? "-06:00" : "-07:00";
}

export function formatDateTimeWithMountainTZ(date: string, time: string): string {
  const tzOffset = getMountainTimeOffset(date);
  return `${date}T${time.padStart(5, "0")}:00${tzOffset}`;
}

export function parseFulfillmentDateTime(
  date: string,
  timeWindow: string | undefined,
): { earliest: string; latest: string } {
  const timeMatch = timeWindow?.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
  const tzOffset = getMountainTimeOffset(date);
  if (!timeMatch) {
    return { earliest: `${date}T00:00:00${tzOffset}`, latest: `${date}T23:59:59${tzOffset}` };
  }
  const [, startTime, endTime] = timeMatch;
  return {
    earliest: `${date}T${startTime.padStart(5, "0")}:00${tzOffset}`,
    latest: `${date}T${endTime.padStart(5, "0")}:00${tzOffset}`,
  };
}

export function getDateInTheFuture(numberOfDays: number, initialDate?: Date): Date {
  const date = initialDate ?? new Date();
  date.setDate(date.getDate() + numberOfDays);

  return date;
}

export function dateToDateInLocalTimezone(date: Date): Date {
  const offsetInMinutes = new Date().getTimezoneOffset();

  const now = new Date();
  const januaryDate = new Date(now.getFullYear(), 0, 1);
  const julyDate = new Date(now.getFullYear(), 6, 1);
  const stdTimezoneOffset = Math.max(januaryDate.getTimezoneOffset(), julyDate.getTimezoneOffset());
  const isDaylightSavingTimeObserved = offsetInMinutes < stdTimezoneOffset;

  return add(date ?? new Date(), { minutes: isDaylightSavingTimeObserved ? offsetInMinutes + 60 : offsetInMinutes });
}

export function dateToDatabaseFormat(date: Date): string {
  return (
    date.toLocaleDateString("en-US", { year: "numeric" }) +
    "-" +
    ("0" + date.toLocaleDateString("en-US", { month: "numeric" })).slice(-2) +
    "-" +
    ("0" + date.toLocaleDateString("en-US", { day: "numeric" })).slice(-2)
  );
}

export function isoStringToLocalDate(isoString: string): Date {
  const [datePart] = isoString.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function getDateAsString(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function dateRangeToString(earliestDate: Date, latestDate: Date): string {
  return `${earliestDate.toLocaleString([], {
    dateStyle: "medium",
  })} at ${earliestDate.toLocaleTimeString([], { hour: "numeric" })} - ${latestDate.toLocaleTimeString([], {
    hour: "numeric",
  })}`;
}

export function databaseDateToLocalTimezone(date: string): string | undefined {
  const parsed = tryParseDate(date);
  if (!parsed) {
    return undefined;
  }
  return dateToDatabaseFormat(dateToDateInLocalTimezone(parsed));
}
